"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = getConfig;
var _send = require("../send");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Requests configuration from the enclosing page.
 *
 * @module core-messaging-dispatch-get-config
 */

/**
 * Request the external configuration object from the receiver. This is called by the
 * "conversation responder" after receipt of the "initialize" action.
 *
 * @param {*} data The data from the requestor
 * @param {*} myNonce The nonce from bootstrap
 */
function getConfig(data, myNonce) {
  // save the nonce that bootstrap sent us, use this to send to them
  (0, _send.setTheirNonce)(data.nonce);
  var payload = {
    nonce: myNonce
  };
  (0, _send.sendMessage)({
    action: 'getConfig',
    data: payload
  });
}
//# sourceMappingURL=get-config.js.map